import { z } from 'zod';

const envSchema = z.object({
  // Factory Addresses - require valid Ethereum addresses
  VITE_FACTORY_ADDRESS_MAINNET: z.string().regex(/^0x[a-fA-F0-9]{40}$/),
  VITE_FACTORY_ADDRESS_TESTNET: z.string().regex(/^0x[a-fA-F0-9]{40}$/),
  
  // Admin Addresses - require valid Ethereum addresses
  VITE_ADMIN_ADDRESS_1: z.string().regex(/^0x[a-fA-F0-9]{40}$/),
  VITE_ADMIN_ADDRESS_2: z.string().optional(),
  VITE_ADMIN_ADDRESS_3: z.string().optional(),

  // WalletConnect Project ID - required for WalletConnect integration
  VITE_WALLETCONNECT_PROJECT_ID: z.string().min(1).optional(),
  
  // RPC Endpoints are now optional since we're using WalletConnect's infrastructure
  VITE_ETH_MAINNET_RPC: z.string().url().optional(),
  VITE_BSC_MAINNET_RPC: z.string().url().optional(),
  VITE_AVALANCHE_MAINNET_RPC: z.string().url().optional(),
});

export function validateEnv() {
  try {
    const env = {
      VITE_FACTORY_ADDRESS_MAINNET: import.meta.env.VITE_FACTORY_ADDRESS_MAINNET,
      VITE_FACTORY_ADDRESS_TESTNET: import.meta.env.VITE_FACTORY_ADDRESS_TESTNET,
      VITE_ADMIN_ADDRESS_1: import.meta.env.VITE_ADMIN_ADDRESS_1,
      VITE_ADMIN_ADDRESS_2: import.meta.env.VITE_ADMIN_ADDRESS_2,
      VITE_ADMIN_ADDRESS_3: import.meta.env.VITE_ADMIN_ADDRESS_3,
      VITE_WALLETCONNECT_PROJECT_ID: import.meta.env.VITE_WALLETCONNECT_PROJECT_ID || 'placeholder',
      VITE_ETH_MAINNET_RPC: import.meta.env.VITE_ETH_MAINNET_RPC || 'https://eth.llamarpc.com',
      VITE_BSC_MAINNET_RPC: import.meta.env.VITE_BSC_MAINNET_RPC || 'https://bsc-dataseed1.binance.org',
      VITE_AVALANCHE_MAINNET_RPC: import.meta.env.VITE_AVALANCHE_MAINNET_RPC || 'https://api.avax.network/ext/bc/C/rpc',
    };

    const result = envSchema.safeParse(env);

    if (!result.success) {
      console.error('❌ Invalid public environment variables');
      console.error(result.error.format());
      return true; // Allow app to continue even with invalid env vars during development
    }

    // Don't log success to avoid exposing values
    return true;
  } catch (error) {
    console.error('❌ Error validating public environment variables', error);
    return true; // Allow app to continue even with invalid env vars during development
  }
}
